/**
 * Filters table data based on user input
 *
 * @param {array} data - The array of row data to be filtered.
 * @param {string} activeProcedure - The displayed procedure type.
 * @param {string} activeSearch - Search string, if any.
 * @param {string} activeState - State to display.
 * @returns {array} tableData - The filter array of table rows.
 */
export default function getFilteredData(data,
  activeProcedure,
  activeSearch,
  activeState) {
  // Make a deep copy of the rows array to avoid side effects.
  const tableData = data.map((row) => ({ ...row }));

  // Set up regex for text search if applicable
  const escapedInput = activeSearch ?
    activeSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : null;

  const regex = new RegExp(escapedInput, 'i');
  return tableData.filter((doctor) => {
    // Filter for procedure presence by year and type
    const matchesProcedure = 'all' === activeProcedure ?
      true : activeProcedure === doctor.pcd;
    // Filter for state
    const matchesSelectedState = 'all' === activeState ?
      true : activeState === doctor.st;
    // Filter for search string
    const matchesSearchString = (regex.test(doctor.nmf) ||
        regex.test(doctor.nml) ||
        regex.test(doctor.hp));

    return (
      matchesProcedure &&
      matchesSelectedState &&
      (activeSearch ? matchesSearchString : true)
    );
  });
}
